import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const homeAssistant = defineConnector({
  identifier: "homeAssistant",
  name: "Home Assistant",
  tagLine: "Open-source home automation",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(`${instanceUrl || "https://homeassistant.local:8123"}/api`),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a long-lived access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Home Assistant, open your profile and select the Security tab, then scroll to “Long-lived access tokens” and create a new token. Copy it now, because you won’t be able to see it again.",
        },
      ],
    },
    {
      title: "Enter your Home Assistant details",
      items: [
        {
          kind: "url",
          label: "Home Assistant URL",
          placeholder: "https://homeassistant.local:8123",
          required: true,
          helperText: "The base URL you use to reach Home Assistant.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Long-lived access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://homeassistant.local:8123"}/api/`,
  },
});
